import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_TABLE,
} from './constants';
import {
  getTablesTranslationKeys,
} from './translations';

export class TablesModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_TABLE, getTablesTranslationKeys);
  }
}
